<template>
  <div class="floor-hotsale">
    <div class="container">
      <div class="floor-head clearfix">
        <h3 class="floor-head__title fl">设备回收</h3>
        <ul class="floor-head__tab fl">
          <li
            class="tab-item"
            v-for="(item, index) in categoryList"
            :key="index"
            :class="{'tab-item--active': item.classId == currentClassId}"
            @click="handleCategoryItemClick(item)">{{ item.className }}</li>
        </ul>
      </div>
      <div class="floor-body clearfix">
        <ul class="brand-list">
          <li
            class="brand-item"
            v-for="(item, index) in brandList"
            :key="index"
            :data-branid="item.brandId"
            :class="{'brand-item--active': currentBrandId == item.brandId}"
            @click="handleBrandClick(item)"
          >
            <img :src="item.brandLogo">
          </li>
          <li class="brand-item">
            <router-link :to="'/products/'+currentClassId">
              <img v-lazy="'https://www.huishoubao.com/www_fendi/new_PC/images/logo-grey/more.png'">
            </router-link>
          </li>
        </ul>
        <ul class="product-list">
          <li class="product-item" v-for="item in productList" :key="item.productId">
            <router-link class="product-link" :to="{name: 'ProductInfo', params: { productId: item.productId }}">
              <img class="product-logo" v-lazy="item.productLogo" :alt="item.productName">
              <h3 class="product-name" v-text="item.productName"></h3>
              <p class="product-desc">最高回收价</p>
              <p class="product-price">￥{{ item.productMaxPrice/100 }}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      categoryList: state => state.indexModels.category.list,
      brandList: state => state.indexModels.brand.list.slice(0, 11),
      productList: state => state.indexModels.product.list.slice(0, 8),
      currentBrandId: state => state.indexModels.currentBrandId,
      currentClassId: state => state.indexModels.currentClassId
    })
  },
  methods: {
    handleBrandClick (brand) {
      this.$store.dispatch('indexModels/handleBrandItemClick', brand);
    },
    handleCategoryItemClick (category) {
      this.$store.dispatch('indexModels/handleCategoryItemClick', category);
    }
  }
};
</script>

<style lang="postcss" scoped>
.floor {
  &-head {
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
    &__title {
      font-size: 24px;
      font-weight: 400;
      color: #333;
    }
    &__tab {
      margin-left: 30px;
      line-height: 28px;
      color: #666;
    }
  }
}

.tab-item {
  float: left;
  margin-right: 20px;
  cursor: pointer;
  &--active {
    color: #ff5f43;
    border-bottom: 1px solid #ff5f43;
  }
}

.brand {
  &-list {
    float: left;
    width: 194px;
    background-color: #fff;
  }
  &-item {
    float: left;
    width: 50%;
    height: 98px;
    background-color: #fff;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    filter: grayscale(1);
    &--active {
      filter: grayscale(0);
    }
  }
}

.product {
  &-list {
    float: left;
    width: 968px;
  }
  &-item {
    float: left;
    width: 231px;
    height: 289px;
    margin-left: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    background: #fff;
    transition: all .3s;
  }
  &-link {
    color: inherit;
  }
  &-logo {
    width: 126px;
    height: 126px;
    margin-top: 40px;
  }
  &-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    margin-top: 26px;
  }
  &-desc {
    color: #999;
    font-size: 12px;
  }
  &-price {
    clear: both;
    margin-top: 10px;
    font-size: 14px;
    color: #ff5f43;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-hotsale.vue